import { BObjectModel, Corporation, CRUD, Person, QueovalBase, Select } from '..';
import { FilterBadgeModel } from '../../filter';
import { BlockTree } from '../blocked';
import { DateRequiredBoProperty } from '../bodisplay/dynamictags-inline/dynamictags-inline.model';
import { BaseQueovalItem, InputModel, QueovalDate, QueovalItem, QueovalParam } from '../global';
import { FilterPlanning, ReservationForUpdate, ReservationPlanning } from './planning.model';


export class PipeStageModel extends QueovalBase {
  //public ComboTypeStage: Array<Select>;
  /*public ComboCursus: Array<Select>;*/

  public IdStage: string;
  public IdCursus: string;
  public IdLinkedData: string;
  public TypeData: string;

  public TypeColumn: string;
  public PipeSearch: Array<QueovalItem>;
  public PipeColumns: Array<PipeColumn>;

  public constructor() {
    super();
    this.PipeSearch = new Array<QueovalItem>();
    this.PipeColumns = new Array<PipeColumn>();
  }
}

export class Pagination {
  public NbElement: number;
  public NbPage: number;
  public CurrentPage: number;
  public Step: number;
  public StepOffeset: number;
  public constructor() {
    this.NbElement = 0;
    this.NbPage = 0;
    this.CurrentPage = 0;
    this.Step = 0;
    this.StepOffeset = 0;
  }
}

export class PipeColumn extends Pagination {
  public Titre: string;
  public TypeColumn: string;
  public IsModeEdit: boolean;
  public Stages: Array<Stage>;
  public PaginationLoading: boolean;
  public constructor() {
    super();
    this.Stages = new Array<Stage>();
  }
}




export class PipeStageFilterModel extends QueovalBase {
  public IdentStage: string;
  public TypeColumn: string;
  public TypeColumnFilter: string;
  public GetPagination: boolean;
  public Pagination: number;
  public PaginationStep: number;
  public PaginationStepOffset: number;
  public DefaultQSOption: string;

  public Filter: Array<FilterBadgeModel>;

  public constructor() {
    super();
    this.IdentStage = '';
    this.TypeColumn = '';    
    this.GetPagination = false;
    this.PaginationStep = 10;
    this.PaginationStepOffset = 0;
    this.Filter = new Array<FilterBadgeModel>();
    this.DefaultQSOption = 'CLI';
  }
}



export enum InfoStageOptionnelle {
  None = 0,
  Client = 1 << 0,
  Formateur = 1 << 1,
  Responsable = 1 << 2,
  Preinscrit = 1 << 3,
  Facturation = 1 << 4,
  All = ~None,
}

export class Stage {
  /// <summary>
  /// tDOProduction : Ident
  /// </summary>
  public Ident: string;

  /// <summary>
  /// tDOProduction : info_PRO
  /// </summary>
  public Titre: string;

  /// <summary>
  /// tDOProduction : datedPRO
  /// </summary>
  public DateDebut: QueovalDate

  /// <summary>
  /// tDOProduction : datefPRO
  /// </summary>
  public DateFin: QueovalDate

  /// <summary>
  /// tDOProduction : Etat_PRO
  /// </summary>
  public Etat: string;

  /// <summary>
  /// tDOProduction : TypsoPRO
  /// </summary>
  public Type: string;

  /// <summary>
  /// tDOProduction : ClotePRO
  /// </summary>
  public Cloture: boolean;

  /// <summary>
  /// ??? : ???
  /// </summary>
  public LogoCPF: string;

  /// <summary>
  /// tDOAdresse : VilleADR
  /// </summary>
  public CpVille: string;

  /// <summary>
  /// tDOProduction : NbstaPRO
  /// </summary>
  public NbStagiaire: number;

  /// <summary>
  /// tDOProduction : NumstPRO
  /// </summary>
  public NumStage: number;


  public NbPreinscrit: number;

  public Responsable: Person;
  public Formateur: Array<Person> = [];
  public Client: Array<Corporation> = [];





  public Loaded: boolean;
}


export class PipeStageVignette extends Stage {


  public MontantPictoColor: string;
  public MontantPictoTitle: string;

  public DatePictoColor: string;
  public DatePictoTitle: string;

  public ClientTitle: string;

  public FormateurToDisplay: Array<String>;
  public FormateurPictoHint: number;
  public FormateurPictoTitle: string;
}




export enum Operator {
  In,
  Egale,
  Superieur,
  Inferieur,
  SuperieurEgale,
  InferieurEgale,
}

export enum ColorReturn {
  GREEN,
  ORANGE,
  RED,
  NONE
}

export class TestStage {
  public Ident: string;
  public Warning: string;
  public Titre: string;
  public Etat: string;
  public Info: string;
  public IdStage: string;
  public EtatRov: ColorReturn;
}

export enum TacheMode {
  MANU = 'MANU',
  AUTO = 'AUTO',
  CURSUS = 'CURSUS',
  NONE = 'NONE',
  PARAM = 'PARAM'
}

export class TacheParam {
  public Ident: string = '0';
  public Code: string = '';
  public Intitule: string;
  public Temps: number = 0;
  public Depense: number = 0;
  public Commentaire: string;
  public DateReference: string = 'datedPRO';
  public NbDeJourDecalage: number = 0;
  public ModeleDocument: string;
  public CreationAutomatique: boolean = false;
  public ModeleEmail: string;
  public ActionAutomatique: string;
  public NotificationCollaborateur: boolean = false;
  public ClotureTache: boolean = false;
  public CodeRelaColla: string;
  public AttachmentToPdf: boolean = false;


  constructor() {


  }
}

export class TacheStage {
  public IdentCollabo: string;
  public IdentTache: string;
  public IdentStage: string;
  public IdentDepense: string;
  public NumstPRO: string;
  public TypeTache: string;
  public Commentaire: string;
  public HasCommentaire: boolean;
  public SeeCommentaire: boolean;
  public Etat: string;
  public EtatCouleur: ColorReturn;
  public ImageCollabo: string;
  public Libelle: string;
  public DateDebut: QueovalDate;
  public DateLimite: QueovalDate;
  public Temps: number;
  public Depense: number;
  public IsSelected: boolean;
  public ModeEditable: boolean;

  // gestion des worflows
  public ModeleDocument: string = '';
  public CreationAutomatique: boolean = false;
  public ModeleEmail: string = '';
  public ActionAutomatique: string = '';
  public NotificationCollaborateur: boolean = false;
  public ClotureTache: boolean = false;
  public AttachmentToPdf: boolean = false;
  


  constructor() {
    this.DateDebut = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), '1');
    this.DateLimite = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), new Date().getDate().toString());
    this.TypeTache = "MANU";
    this.IdentTache = "0";
    this.IdentDepense = "0";
    this.Etat = "1";
    this.ModeEditable = false;
    this.ModeleDocument = '';
    this.CreationAutomatique = false;
    this.ModeleEmail = '';
    this.ActionAutomatique = '';
    this.NotificationCollaborateur = false;
    this.ClotureTache = false;

  }
}



export class TacheStageCursusInfo {
  public IdentCursus: string;
  public NomCursus: string;
  public TotalTempsCursus: number;
  public TotalDepensesCursus: number;
  public LstTacheIsEmpty: boolean;
  public StageHasCursus: boolean;
  public LstInfoStage: StageInfo[];
}

export class StageInfo {
  public IdentStage: string;
  public NumStage: string;
  public NomStage: string; 
  public DateDebutStage: string;
  public DateLimiteStage: string;
}

 
//  #region Onglet Extranet
export class ExtraQuestionnaireStage {
  public LstQuestionnaires: Array<InfosQuestionnaire>;
  public IsModEdit: boolean;
  public IdentPropToUpdate: string;
  public GroupPropToUpdate: string;
  public DateToUpdate: DateRequiredBoProperty;
  public GroupDateToUpdate: string;
  public IdentStage: string;

}

export class InfosQuestionnaire {
  public Labelle: string;
  public IsModEdit: boolean;
  public PropIsSelected: boolean;
  public TypeQuestionnaire: string;
  public ClassDatePick: string;
  public DateIsActivated: boolean;
  public DateActivation: DateRequiredBoProperty;
  public LstInfosProps: Array<infosProp>;

}

export class infosProp {
  public TypeQuestionnaire: string;
  public Ident: string;
  public Titre: string;
  public IsSelected: boolean;

}

export class ExtraGestionAcces {
  public NiveauRole: string;
  public Action: CRUD;  
  public LstIdentApprenant: Array<string>;
  public LstIdentFormateur: Array<string>;
  public LstIdentResponsableRH: Array<string>;
  
}

// #endregion

//  #region vue 360
export class StageDocu360 {
  public LstDocuments: DocumentFor360[];
}

export class DocumentFor360 {
  public Ident: string;
  public Titre: string;
  public Type: string;
}

export class StageDuplicationModel {
  public IdentNewStage: string;
  public IdentOldStage: string;
  public BoALier: Array<string>;
}
// #endregion

//model pour le composant lieu
export class InfoAdresse extends QueovalBase {
  public Ident: string;
  public Denomination: string;
  public AdresseComplete: string;
  public Adresse1: string;
  public Adresse2: string;
  public Adresse3: string;
  public VilleAdress: string;
  public Latitude: number;
  public Longitude: number;
  // infos pour le BO
  public ModelBO: BObjectModel;

  // Liste des lieux de convocation
  public ListConvocationLocation: Array<Select>;

  // Liste des clients (pour récupérer leur adresse)
  public ListClient: Array<Select>;

  // Liste des champs adresse pour le client
  public ListInputAdressClient: Array<InputModel>;

  // BO lieu de convocation 
  public BoLieuConvocation: BObjectModel;
}

//ReservationDocModel, ReservationDataDoc, FormateurData = model pour la reservation (onglet Documents)
export class ReservationDocModel extends QueovalBase {
  public ImgSingleFormateur: string; 
  public FiltreDateDebut: QueovalDate;
  public FiltreDateFin: QueovalDate;
  public LstFormateur: FormateurData[];
  public LstReservation: ReservationDataDoc[];
}

export class ReservationDataDoc {
  public Ident: string;
  public IsSelected: boolean;
  public FullTitreDate: string;
  public Titre: string;
  public DateDebut: QueovalDate;
  public DateFin: QueovalDate;
  public LstFormateurRattache: FormateurData[];
}

export class FormateurData {
  public Ident: string;
  public Image: string;
  public FullName: string;
  public Nom: string;
  public Prenom: string;
}

//#region onglet Document

export class StageDocumentFormationModel {
  constructor() {   
    this.IdDocument = '';
    this.IdStage = '';
    this.ModeSeparation
    this.Stagiaires = [];
    this.Clients = [];
    this.Reservations = [];
    this.IdReport = '';
    this.Model = '';
  }
  public IdDocument: string;
  public IdStage: string;
  public ModeSeparation: string;
  public Stagiaires: Array<string>;
  public Clients: Array<string>;
  public Reservations: Array<string>;
  public IdReport: string;
  public Model: string;
}

export class StageDocumentUpdate {
  public StringData: string;
  public DocumentIdentList: Array<string>;
  public TypeDocument: string;
}

export class StageDocumentContract {
  public IdStage: string;
  public IdTrainer: string;
  public Contract: ContractData;
  public LstIdentReservation: Array<string>;
}

export class ContractData {
  public Cout: number;
  public ModeCalculJour: boolean;
  public NbHoursStage: number;
  public NbJour: number;
  public TauxTVA: number;
  public MontantHT: number;
  public MontantTVA: number;
  public MontantTTC: number;
  public Modele: string;
}

//#endregion

//#region onglet Planning

export class PlanningFormationModel extends QueovalBase {
  public DureeStage: number;
  public DataFilter: FilterPlanning;
  public DateDebut: QueovalDate;
  public DateFin: QueovalDate;
  public ListeReservations: Array<ReservationPlanning>;
  public ListConvocationLocation: Array<Select>;
  public ListBureaux: Array<Select>;
  public ListDispo: Array<Select>;
  public AllObjects: BlockTree;
  public ReservForUpdate: ReservationForUpdate;
  public IdStage: string;
}

//#endregion

//#region onglet Certification

export class CertificationApprenant {
  public IdStage: string;
  public Apprenants: Array<string>;
  public BoPosition: BObjectModel;
}


export class CertificationIdent {
  public  IdStage: string;
  public IdApprenant: string;
  public IdPosition: string;
  public CodeBoPosition: string;
}

export class BilanPedagogique {
  public Date: QueovalDate;
  public Comment: string;
  public IdStage: string;
  public ObjPedaList: Array<ObjectifPedagogique>;
}

export class ObjectifPedagogique {
  public Title: string;
  public LearnerList: Array<OPLearner>;
  public ReachedList: Array<BaseQueovalItem>;
}

export class OPLearner {
  public Ident: string;
  public FirstName: string;
  public LastName: string;
  public ObjectifState: string;
}

//#endregion

